import { NgModule } from '@angular/core';
import { TransactionFiltersComponent } from './transaction-filters.component';
import { CurrencyInputModule } from '../../../../shared/currency-input/currency-input.module';
import { DatepickerModule } from '../../../../shared/datepicker/datepicker.module';
import { SharedModule } from '../../../../shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OrganizationService } from '../../../../../services/organization/organization.service';
import { CategorySelectModule } from '../../chart-of-accounts/category-select/category-select.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
    imports: [
        SharedModule,
        CurrencyInputModule,
        DatepickerModule,
        MatCheckboxModule,
        CategorySelectModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
    ],
    exports: [TransactionFiltersComponent],
    declarations: [TransactionFiltersComponent],
    providers: [
        OrganizationService,
    ],
})
export class TransactionFiltersModule
{
}
